module.exports = __webpack_public_path__ + "img/admin.2275f085.png";